<template>
  <GetStartedInstructions
    :class="$style.recommendedCommandQueue"
    dismissButtonClass=""
    dismissButtonText="dismiss forever"
    :localStorageKey="localStorageKey"
    :showDismiss="true"
    :startCollapsed="false"
    title="About the Command Queue"
  >
    <div>
      <ParagraphBody>
        View and manage pending commands from the Commands Queue.
        See the number of devices to which the command is assigned.
        Cancelling a command will affect only the devices in the pending column.
        Click a command to view details or remove the command from a device.
        Learn more in <Link
          href="https://support.jumpcloud.com/s/article/about-queued-commands"
          :isExternal="true"
          target="_blank"
          text="Manage Queued Commands"
        />
      </ParagraphBody>
    </div>
  </GetStartedInstructions>
</template>

<script>
import { Link, ParagraphBody } from '@jumpcloud/ui-components';
import { LocalStorageConsts } from 'client/util/Constants';
import GetStartedInstructions from 'client/components/GetStartedInstructions/GetStartedInstructions.vue';

const { recommendedCommandQueueDismissed } = LocalStorageConsts;

export default {
  name: 'RecommendedCommandQueue',

  components: {
    GetStartedInstructions,
    ParagraphBody,
    Link,
  },

  data() {
    return {
      localStorageKey: recommendedCommandQueueDismissed,
    };
  },
};
</script>

<style module>

.recommendedCommandQueue button {
  background: none;
  cursor: pointer;
  text-decoration: underline;
}
</style>
